// import React from "react";
// import ReactDOM from "react-dom/client";
// import { Provider } from "react-redux";
// import { BrowserRouter, HashRouter } from "react-router-dom";

// import { SnackbarProvider } from 'notistack';
// import Routes from "routes/route";
// import store from "store/store";
// import { ColorProvider } from "utils/UIContext";
// import { LoaderProvider } from "Context/LoaderContext";
// import FullScreenLoader from "Context/FullScreenLoader";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//     <React.StrictMode>
//         <Provider store={store}>
//             <ColorProvider>
//             <LoaderProvider>
//             <SnackbarProvider autoHideDuration={3000} maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
//                 <BrowserRouter>
//                 <FullScreenLoader/>
//                     <Routes />
//                 </BrowserRouter>
//             </SnackbarProvider>
//             </LoaderProvider>
//             </ColorProvider>
//         </Provider>
//     </React.StrictMode>
// );


import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";

import Routes from "routes/route";
import store from "store/store";
import { ColorProvider } from "utils/UIContext";
import { LoaderProvider } from "Context/LoaderContext";
import FullScreenLoader from "Context/FullScreenLoader";

import { AuthProvider } from "oidc-react";
import { initialOidcConfigChartwell, oidcConfig as initialOidcConfigLive, initialOidcConfigQIAshop, initialOidcConfigSyringa } from "./oidc-config";
import { oidcConfigBeta as initialOidcConfigBeta } from "./oidc-config";
import { isMobile } from "react-device-detect";
import { ModalProvider } from "utils/SignupContext";
import { CartProvider } from "utils/CartContext";
import { FooterVisibilityProvider } from "Context/FooterContext";
import { IS_BETA, IS_LIVE } from "constants/appConstants";
import { StoreProvider } from "utils/OfflineContext";
import { StoreStatusProvider } from "Context/StoreStatusContext";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "styles/theme/theme";
import ScrollToTop from "components/scroll/ScrollToTop";
// Helper function to get URL parameters
const getParameterByName = (name, url) => {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  const results = regex.exec(url || window.location.href);
  return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
};
// Check for token_nonce in URL
const tokenNonce = getParameterByName("token_nonce");
// ✅ After render: check if user is already logged in
window.addEventListener('DOMContentLoaded', () => {
  const hostname = window.location.hostname;

  if (hostname.includes('alora')) {
    // Get email from where you store it (example: localStorage, Redux, etc.)
    const userEmail = localStorage.getItem('u_user_data'); // OR your auth context

    if (userEmail && window.dataLayer) {
      window.dataLayer.push({
        event: 'email_tracking',
        userEmail: JSON.parse(userEmail)?.email,
      });
    }
  }
});
// Clone and update the OIDC config with token_nonce if present
// const oidcConfigProd = { ...initialOidcConfigLive };
// const oidcConfigTest = { ...initialOidcConfigBeta };
// const oidcConfig = IS_BETA.includes(window?.location?.host) ? oidcConfigTest : IS_LIVE.includes(window?.location?.host) ? oidcConfigProd : oidcConfigProd;

// const isAuthApp = window?.location?.host === "mclardies.webbieshop.com" || window?.location?.host === "d6auth.vercel.app" ;
// 🧹 Clear all cart-related localStorage
function clearCart() {
  console.log("🧹 Clearing cart (new day or 11:59 PM)...");

  localStorage.removeItem("cartItems");
  localStorage.removeItem("localNotes");
  localStorage.removeItem("transaction_id");

  // Save the date when cart was cleared
  localStorage.setItem("lastClearDate", new Date().toDateString());
}


// 📌 Check if a new day has started (even if website was closed)
function clearCartIfNewDay() {
  const today = new Date().toDateString();
  const lastClearDate = localStorage.getItem("lastClearDate");

  if (lastClearDate !== today) {
    clearCart();
  }
}


// 📌 Schedule a clear at exactly 11:59 PM (works only when site is open)
function scheduleDailyCartClear() {
  const now = new Date();
  const nextClear = new Date();

  // Set nextClear to today at 23:59:00
  nextClear.setHours(23, 59, 0, 0);

  // If it's already past 11:59 PM, schedule for tomorrow
  if (now > nextClear) {
    nextClear.setDate(nextClear.getDate() + 1);
  }

  const timeUntilClear = nextClear - now;

  console.log("⏳ Cart will auto-clear at 11:59 PM in", timeUntilClear / 1000, "seconds");

  setTimeout(() => {
    clearCart();          // Clear at 11:59 PM
    scheduleDailyCartClear(); // Reschedule for next day
  }, timeUntilClear);
}


// 📦 One-time fix to clear stale 'number' key from users' local storage
function removeStaleNumberOnce() {
  const hasCleared = localStorage.getItem("has_cleared_stale_number");
  
  if (!hasCleared) {
    console.log("🧹 Running one-time cleanup to clear stale 'number' from local storage...");
    localStorage.removeItem("number");
    localStorage.setItem("has_cleared_stale_number", "true");
  }
}

// 🚀 Call on page load
// removeStaleNumberOnce();
clearCartIfNewDay();   // Clear if new day (site was closed)
scheduleDailyCartClear(); // Also clear at 11:59 PM if site is open

const oidcConfigProd = { ...initialOidcConfigLive };
const oidcConfigTest = { ...initialOidcConfigBeta };
const oidcConfigChartwell = { ...initialOidcConfigChartwell };
const oidcConfigSyringa = { ...initialOidcConfigSyringa };
const oidcConfigQIAtuckshop = { ...initialOidcConfigQIAshop };

const oidcConfig =
  IS_BETA.includes(window?.location?.host)
    ? oidcConfigTest
    : IS_LIVE.includes(window?.location?.host)
      ? oidcConfigProd
      : window?.location?.host === "broadacreschartwell.webbieshop.com"
        ? oidcConfigChartwell
        : window?.location?.host === "broadacressyringa.webbieshop.com"
          ? oidcConfigSyringa
          : window?.location?.host === "qiatuckshop.webbieshop.com"
            ? oidcConfigQIAtuckshop
            : oidcConfigTest;

const isAuthApp =
  window?.location?.host === "mclardies.webbieshop.com" ||
  window?.location?.host === "d6auth.vercel.app" ||
  window?.location?.host === "broadacreschartwell.webbieshop.com" ||
  window?.location?.host === "broadacressyringa.webbieshop.com" ||
  window?.location?.host === "qiatuckshop.webbieshop.com";

const root = ReactDOM.createRoot(document.getElementById("root"));

if (isAuthApp) {
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <StoreProvider>
          <FooterVisibilityProvider>
            <AuthProvider {...oidcConfig} autoSignIn={(tokenNonce) ? true : false}>
              <Provider store={store}>
                <CartProvider>

                  <SnackbarProvider
                    autoHideDuration={1000}
                    maxSnack={3}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  >
                    <ModalProvider>
                      <StoreStatusProvider>
                        <ColorProvider>
                          <LoaderProvider>
                            <BrowserRouter>
                            <ScrollToTop/>
                              <FullScreenLoader />
                              <Routes />
                            </BrowserRouter>
                          </LoaderProvider>
                        </ColorProvider>
                      </StoreStatusProvider>
                    </ModalProvider>
                  </SnackbarProvider>
                </CartProvider>
              </Provider>
            </AuthProvider>
          </FooterVisibilityProvider>
        </StoreProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  // Render Regular App
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <StoreProvider>
          <FooterVisibilityProvider>
            <AuthProvider {...oidcConfig} autoSignIn={false}>
              <Provider store={store}>
                <CartProvider>
                  <ColorProvider>
                    <SnackbarProvider
                      autoHideDuration={1000}
                      maxSnack={3}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    >
                      <ModalProvider>
                        <StoreStatusProvider>
                          <LoaderProvider>
                            <BrowserRouter>
                            <ScrollToTop/>
                              <FullScreenLoader />
                              <Routes />
                            </BrowserRouter>
                          </LoaderProvider>
                        </StoreStatusProvider>
                      </ModalProvider>
                    </SnackbarProvider>
                  </ColorProvider>
                </CartProvider>
              </Provider>
            </AuthProvider>
          </FooterVisibilityProvider>
        </StoreProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
}
